/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { getMeta } from "app/utils/meta";
import {
  Accordion,
  AccordionContext,
  AccordionItem,
  AccordionPanel,
} from "app/components/accordion";
import Link from "app/components/i18n/Link";
import Layout from "app/components/layout";
import { MobilePaymentSystems } from "app/sections/payment-policy/mobile-payment-systems";
import { PaymentProcessors } from "app/sections/payment-policy/payment-processors";
import { ZbooniFees } from "app/sections/payment-policy/zbooni-fees";
import { Fragment, useRef } from "react";

export const meta = getMeta({
  title: "Payment Policy | Protecting and respecting your data",
});

const PaymentPolicy = () => {
  const zbooniFeesRef = useRef();

  return (
    <Layout headerIsOnTop={false} enableHeaderShrinkingOnScroll={false}>
      <header className="bg-primary">
        <div className="zbooni-layout pb-7 sm:pb-9 pt-24 sm:pt-32">
          <h1 className="text-2xl font-extrabold text-white xs:text-[28px] sm:text-[32px]">
            Payment Policy
          </h1>
        </div>
      </header>
      <div className="bg-white text-sm sm:text-base py-8">
        <div className="zbooni-layout">
          <div className="flex flex-col gap-y-7">
            <div className="flex flex-col italic">
              <p>Effective Date on: July 30, 2023</p>
              <p>Last updated on: July 31, 2023</p>
            </div>
            <p>
              This Payment Policy (“
              <span className="font-bold">Policy</span>
              ”) forms part of the Agreement, as defined under the Terms and
              Conditions located at{" "}
              <Link to="/terms/" className="text-blue underline">
                https://www.zbooni.com/terms
              </Link>
              . All undefined capitalized terms used in this Policy have their
              meaning ascribed to them under the Terms and Conditions.
            </p>
            <p>
              We reserve the right to change, in our sole discretion, any of the
              terms of this Policy by publishing the varied terms on the
              Website, with or without notice. Accordingly, you are responsible
              for reviewing regularly information posted online to obtain timely
              notice of such changes. As such, we recommend that you check the
              Website and your Zbooni Account regularly to ensure you are aware
              of our current terms. Your continued use of any part of the
              Services after changes are posted constitutes your acceptance of
              the latest version of the Policy and Agreement as modified by the
              posted changes.
            </p>
          </div>
          <Accordion active="subscription-modules" scrollToDiv={true}>
            <AccordionContext.Consumer>
              {({ togglePanel }) => (
                <Fragment>
                  <AccordionItem
                    id="subscription-modules"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>1.</span>
                        <span>Subscription Modules</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="subscription-modules"
                    className="border-b"
                  >
                    <div className="mb-10 flex flex-col gap-y-5">
                      <div className="pl-6 sm:pl-10">
                        <p className="flex gap-x-5">
                          <span>1.1.</span>
                          <span>
                            Zbooni offers the following Service Modules which
                            may be availed by Merchants as set out below.
                          </span>
                        </p>
                        <div className="pl-6 sm:pl-10">
                          <p className="underline">1.1.1. &nbsp; All-in-One</p>
                          <ol className="roman pl-6 sm:pl-10">
                            <li>
                              Payments powered by Zbooni. Ideal for businesses
                              that do not currently accept online payments. It
                              is the fastest way to get started. Please refer to{" "}
                              <Link
                                to="/pricing/all-in-one/"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/pricing/all-in-one/
                              </Link>{" "}
                              for further details regarding the All-in-One
                              Service Module.
                            </li>
                            <li>
                              The All-in-One Service Module may be availed by
                              Merchants operating in the following Territories:
                              <ol className="alphabet pl-6 sm:pl-10">
                                <li>United Arab Emirates</li>
                                <li>Kingdom of Saudi Arabia</li>
                                <li>Egypt</li>
                                <li>Jordan</li>
                              </ol>
                            </li>
                          </ol>
                        </div>
                        <div className="pl-6 sm:pl-10">
                          <p className="underline">1.1.2. &nbsp; Integrated</p>
                          <ol className="roman pl-6 sm:pl-10">
                            <li>
                              Integrate with your existing payment provider.
                              Unlock cCommerce with your existing payment
                              provider. Please refer to{" "}
                              <Link
                                to="/pricing/integrated/"
                                className="text-blue underline"
                              >
                                https://www.zbooni.com/pricing/integrated/
                              </Link>{" "}
                              for further details regarding the Integrated
                              Service Module.
                            </li>
                            <li>
                              The Integrated Service Module may be availed by
                              Merchants operating in all Territories.
                            </li>
                          </ol>
                        </div>
                        <div className="pl-6 sm:pl-10">
                          <p className="underline">1.1.3 &nbsp; Custom</p>
                          <p className="pl-6 sm:pl-10">
                            Zbooni, may, in its sole and absolute discretion,
                            offer you a bespoke Service Module, tailored to your
                            specific needs. Please contact us at{" "}
                            <a
                              className="text-blue underline"
                              href="mailto:hello@zbooni.com"
                              lang="en"
                            >
                              hello@zbooni.com
                            </a>{" "}
                            for further details.
                          </p>
                        </div>
                      </div>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.2.</span>
                        <span>
                          At the time of registering your Zbooni Account, you
                          may select one of the Service Modules offered by
                          Zbooni. Please refer to{" "}
                          <Link
                            to="/pricing/all-in-one/"
                            className="text-blue underline"
                          >
                            https://www.zbooni.com/pricing/all-in-one/
                          </Link>{" "}
                          for further details regarding each of the Service
                          Modules.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.3.</span>
                        <span>
                          After selecting your preferred Service Module, Zbooni
                          will verify all your information in accordance with
                          Clause 4 of the Terms and Conditions and, in its sole
                          and absolute discretion, determine if you are eligible
                          to use such Service Module. You expressly agree and
                          acknowledge that Zbooni may also share your
                          information with our Payment Processors and local
                          financial institutions, each of which may also decide
                          regarding your eligibility. We will notify you at your
                          email address provided to us during the registration
                          process once your Zbooni Account has been either
                          approved or deemed ineligible for use, access, and
                          subscription of such Service Module.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.4.</span>
                        <span>
                          You may at, any time, choose to change your selected
                          Service Module through your Zbooni Account or by
                          emailing us at{" "}
                          <a
                            className="text-blue underline"
                            href="mailto:hello@zbooni.com"
                            lang="en"
                          >
                            hello@zbooni.com
                          </a>{" "}
                          (“
                          <span className="font-bold">
                            Service Module Change Request
                          </span>
                          ”). In the event you elect to change the Service
                          Module, such change may only be effected once (i)
                          additional verification, as determined by Zbooni
                          acting in its sole and absolute discretion, is
                          completed to the satisfaction of Zbooni, (ii) all
                          integration activities as deemed necessary by Zbooni
                          have been completed to the satisfaction of Zbooni, and
                          (iii) all training, testing, and tutorials as deemed
                          necessary by Zbooni have been completed to the
                          satisfaction of Zbooni (collectively, “
                          <span className="font-bold">
                            Service Module Change Verification
                          </span>
                          ”). Please note that during the interim period, the
                          Service Module you subscribed for immediately
                          preceding such Service Module Change Request will be
                          active.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.5.</span>
                        <span>
                          After the completion of the Service Module Change
                          Verification, Zbooni will, in its sole and absolute
                          discretion, determine if you are eligible to change
                          your Service Module. You expressly agree and
                          acknowledge that Zbooni may also share your
                          information with our Payment Processors and local
                          financial institutions, each of which may also decide
                          regarding your eligibility. We will notify you at your
                          email address provided to us during the registration
                          process once your Service Module Change Request has
                          been either approved or rejected.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>1.6.</span>
                        <span>
                          In the event your Service Module Change is rejected,
                          you may continue using the Services pursuant to the
                          Service Module you subscribed for immediately
                          preceding such Service Module Change Request or elect
                          to terminate your relationship with us in accordance
                          with Clause 9 of the Terms and Conditions{" "}
                          <Link to="/terms/" className="text-blue underline">
                            https://www.zbooni.com/terms
                          </Link>
                          .
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="payment-processors"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>2.</span>
                        <span>Payment Processors</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="payment-processors" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10 ">
                        <span>2.1.</span>
                        <span>
                          Zbooni uses specific Payment Processors for
                          transactions pursuant to each of the Service Modules
                          as set out in Schedule 1 of this Policy. By using
                          and/or accessing any Service Module, you indicate that
                          you have read, acknowledged, agreed, and accepted the
                          terms of service, privacy policy, and other terms and
                          policies of such Payment Processors. Zbooni may,
                          acting in its sole and absolute discretion, change
                          Payment Processors who are processing and settling any
                          of your Transactions from time to time.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10 ">
                        <span>2.2.</span>
                        <span>
                          Zbooni reserves the right to take measures in
                          accordance with applicable law in the event a Payment
                          Processor experiences any network interruption or
                          technical glitches. However, you acknowledge and agree
                          that Zbooni is neither responsible nor liable for any
                          technical malfunctions, network interruptions, network
                          failures, or other issues that Payment Processors may
                          experience which may have an impact on the Service
                          from time to time.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="payment-services"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>3.</span>
                        <span>Payment Services</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="payment-services" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.1.</span>
                        <span>
                          The payments services offered by Zbooni may include,
                          depending on the Service Module, (collectively, “
                          <span className="font-bold">Payments Services</span>”)
                          (i) payment account boarding, (ii) payment
                          underwriting, and (iii) payment data transmission
                          service that helps you integrate with a Payment
                          Processor.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.2.</span>
                        <span>
                          Zbooni grants you a non-exclusive, non-transferable,
                          non-sublicensable, limited, revocable right to use the
                          Payments Services (“
                          <span className="font-bold">
                            Payment Services License
                          </span>
                          ”). The Payment Services License shall be for the term
                          of this Agreement only. Neither the Payment Service
                          License nor any other provision of the Agreement shall
                          grant any rights in the Payments Services or other
                          intellectual property rights except the limited
                          Payment Services License as expressly stated in this
                          Clause 3.1.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.3.</span>
                        <span>
                          You shall not: (i) permit any third party to access
                          the Payments Services, including, but not limited to,
                          your Zbooni Account, except as permitted herein, and
                          to carry out Transactions; (ii) create derivate works
                          based on the Payments Services; (iii) copy, frame or
                          mirror any part of the content of the Payments
                          Services, other than copying or framing for your
                          internal business purposes; (iv) reverse engineer,
                          disassemble, decompile, or otherwise attempt to
                          discover the source code or trade secrets for any of
                          the Payments Services; or, (v) access the Payments
                          Services in order to build a competitive product or
                          service.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.4.</span>
                        <span>
                          It is your responsibility to obtain your customers’
                          consent to be billed for each Transaction or, as the
                          case may be, on a recurring basis, in compliance with
                          applicable legal requirements and Visa Europe Ltd.,
                          Visa U.S.A., Inc., Visa Canada Inc. and Visa
                          International (collectively, “
                          <span className="font-bold">Visa</span>
                          ”), MasterCard International Incorporated (“
                          <span className="font-bold">MasterCard</span>”),
                          American Express or other applicable Card networks’
                          (such networks being, collectively, “
                          <span className="font-bold">Payment Networks</span>”)
                          payment rules (“
                          <span className="font-bold">
                            Payment Network Rules
                          </span>
                          ”).
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>3.5.</span>
                        <span>
                          You are required to comply with all applicable Payment
                          Network Rules. The Payment Network Rules for Visa,
                          MasterCard and American Express are available on at
                          the following links:{" "}
                          <a
                            href="https://usa.visa.com/content/dam/VCOM/download/about-visa/visa-rules-public.pdf"
                            rel="noreferrer"
                            target="_blank"
                            className="text-blue underline"
                          >
                            VISA
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://www.mastercard.com/content/dam/mccom/shared/business/support/rules-pdfs/mastercard-rules.pdf"
                            rel="noreferrer"
                            target="_blank"
                            className="text-blue underline"
                          >
                            MasterCard
                          </a>
                          . The Payment Networks may amend the Payment Network
                          Rules at any time and without notice. In the event of
                          any inconsistency between this Agreement, and the
                          Payment Network Rules, the specific provisions of the
                          Payment Network Rules shall prevail. We reserve the
                          right to amend this Agreement at any time, with notice
                          to you, as may be necessary to comply with the Payment
                          Network Rules.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="mobile-payment-systems"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>4.</span>
                        <span>Mobile Payment Systems</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="mobile-payment-systems"
                    className="border-b"
                  >
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>4.1.</span>
                        <span>
                          Depending on the Service Module and your location, we
                          may offer you to use the mobile payment system
                          supported gateways set out in Schedule 2 of this
                          Policy (collectively, “
                          <span className="font-bold">
                            MPS Supported Gateways
                          </span>
                          ”).
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>4.2.</span>
                        <span>
                          By using any MPS Supported Gateways, you agree and
                          acknowledge that you shall be bound by the terms and
                          conditions and policies of such MPS Supported
                          Gateways, as may be amended from time to time. Your
                          continued use of any such MPS Supported Gateways after
                          any the amendments to their terms and conditions
                          and/or policies, constitutes your agreement to, and
                          acceptance of, such amended terms. If you do not agree
                          to any changes to such terms, do not continue to use
                          such MPS Supported Gateway.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="fees"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>5.</span>
                        <span>Fees</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="fees" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>5.1.</span>
                        <span>
                          As consideration for providing the Services, Zbooni
                          shall retain amounts valued in accordance with the fee
                          schedule set out in Schedule 3 of this Policy (“
                          <a
                            onClick={() => {
                              togglePanel("schedule-3-zbooni-fees");
                              zbooniFeesRef.current?.scrollIntoView();
                            }}
                            className="font-bold cursor-pointer"
                          >
                            Zbooni Fees
                          </a>
                          ”).
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>5.2.</span>
                        <span>
                          We reserve the right to revise our Zbooni Fees at any
                          time, subject to a thirty (30) day notice period to
                          you.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="disbursements"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>6.</span>
                        <span>Disbursements</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="disbursements" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.1.</span>
                        <span>
                          All disbursements amounts shall be disbursed to you
                          through bank transfers from the Deposit Account to
                          your Merchant Account. Funds for any given transaction
                          will not be transferred to your Merchant Account until
                          the Transaction is deemed complete. Transactions will
                          be deemed complete when we have received funds
                          settling from the Payment Networks and when we or our
                          processing financial institutions have accepted such
                          funds.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.2.</span>
                        <span>
                          You further agree and acknowledge that Zbooni cannot
                          and will not assume any responsibility or liability
                          for any incorrect banking or other account information
                          provided by the Merchant.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.3.</span>
                        <span>
                          Zbooni shall disburse the funds settling from the
                          Payment Networks to your Merchant Account in the
                          amounts actually received, net of the Zbooni Fees,
                          Chargebacks, and other funds owed to us for any reason
                          as set out in the Terms and Conditions.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.4.</span>
                        <span>
                          Further, Zbooni shall bear the initial transfer cost
                          arising from initiating the transfer of settlement
                          funds to your Merchant Account. However, you agree and
                          acknowledge that we shall not bear any other costs
                          associated with the receipt of payment by Merchant.
                          These additional charges may include local bank costs,
                          charges and fees, intermediary bank costs, charges and
                          fees, currency exchange/forex costs, charges and fees,
                          fees and costs associated with applicable laws,
                          compliance and KYC costs, charges and fees, and other
                          administrative costs, charges and fees which may be
                          issued by financial institutions and/or governmental
                          authorities. Accordingly, the total amount received by
                          the Merchant will also depend on any such charges,
                          costs and fees.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.5.</span>
                        <span>
                          The Payment Processor, on behalf of Zbooni, reserves
                          the right to change the Payout Schedule or suspend
                          payouts to your Merchant Account should we determine
                          it is necessary due to pending disputes, excessive or
                          anticipated excessive Chargebacks or refunds, or other
                          suspicious activity associated with your use of the
                          Service including but not limited to failure to meet
                          any verification standards set out by Zbooni in this
                          Agreement or if required by law or court order.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>6.6.</span>
                        <span>
                          If your account remains inactive, if you fail to
                          provide valid and up-to-date bank details, or if you
                          do not request a payout for a period of 24 consecutive
                          months, any proceeds or balances associated with your
                          account may be considered unclaimed or abandoned in
                          accordance with this policy. In such cases, Zbooni may
                          be required to transfer the funds to the appropriate
                          authority or may otherwise manage the funds as
                          permitted by law. It is your responsibility to keep
                          your account information current and to claim your
                          proceeds before the expiration period to avoid delays
                          or forfeiture.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="timing-of-payouts"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>7.</span>
                        <span>Timing Of Payouts</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="timing-of-payouts" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-5">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>7.1.</span>
                        <span>
                          You may request for disbursements of your payouts by
                          selecting the “Request For Payouts” function on your
                          Zbooni Account, which shall be initiated by Zbooni as
                          soon as possible.
                        </span>
                      </p>
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>7.2.</span>
                        <span>
                          The transfer of settlement funds to the Merchant
                          Account is dependent on the bank timescales. While the
                          settlement funds should normally be credited to your
                          Merchant Account within 1-2 business days of Zbooni
                          initiating the payout, Zbooni cannot provide a firm
                          date and you should refer to your bank for guidance.
                          Payments initiated to the Merchant Account, as
                          evidenced by confirmation from Zbooni, shall be deemed
                          full and final settlement of the amounts owed to the
                          Merchant. Further, we are not responsible for any
                          action taken by the institution holding your Merchant
                          Account that may result in some or all of the funds
                          not being credited to your Merchant Account or not
                          being made available to you in your Merchant Account.
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="questions"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="flex gap-x-3 sm:gap-x-6 text-lg font-extrabold sm:text-xl">
                        <span>8.</span>
                        <span>Questions</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel id="questions" className="border-b">
                    <div className="mb-10 flex flex-col gap-y-7">
                      <p className="flex gap-x-5 pl-6 sm:pl-10">
                        <span>8.1.</span>
                        <span>
                          If you have any questions regarding this Policy,
                          please contact us at{" "}
                          <a
                            className="text-blue underline"
                            href="mailto:hello@zbooni.com"
                            lang="en"
                          >
                            hello@zbooni.com
                          </a>
                          .
                        </span>
                      </p>
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="schedule-1-payment-processors"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="text-lg font-extrabold sm:text-xl flex flex-col">
                        <span>Schedule 1</span>
                        <span>Payment Processors</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="schedule-1-payment-processors"
                    className="border-b"
                  >
                    <div className="mb-10">
                      <PaymentProcessors />
                    </div>
                  </AccordionPanel>
                  <AccordionItem
                    id="schedule-2-mobile-payment-systems"
                    className="flex justify-between h-[124px]"
                  >
                    <div className="flex items-center">
                      <p className="text-lg font-extrabold sm:text-xl flex flex-col">
                        <span>Schedule 2</span>
                        <span>Mobile Payment Systems</span>
                      </p>
                    </div>
                  </AccordionItem>
                  <AccordionPanel
                    id="schedule-2-mobile-payment-systems"
                    className="border-b"
                  >
                    <div className="mb-10">
                      <MobilePaymentSystems />
                    </div>
                  </AccordionPanel>
                  <div ref={zbooniFeesRef}>
                    <AccordionItem
                      id="schedule-3-zbooni-fees"
                      className="flex justify-between h-[124px]"
                    >
                      <div className="flex items-center">
                        <p className="text-lg font-extrabold sm:text-xl flex flex-col">
                          <span>Schedule 3</span>
                          <span>Zbooni Fees</span>
                        </p>
                      </div>
                    </AccordionItem>
                    <AccordionPanel
                      id="schedule-3-zbooni-fees"
                      className="border-b"
                    >
                      <div className="mb-10">
                        <ZbooniFees />
                      </div>
                    </AccordionPanel>
                  </div>
                </Fragment>
              )}
            </AccordionContext.Consumer>
          </Accordion>
        </div>
      </div>
    </Layout>
  );
};

export default PaymentPolicy;
